import script from "./middle-pdf.vue?vue&type=script&setup=true&lang=js"
export * from "./middle-pdf.vue?vue&type=script&setup=true&lang=js"

import "./middle-pdf.vue?vue&type=style&index=0&id=81a93480&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-81a93480"]])

export default __exports__